// Auto-generated from sources.md — do not edit manually
export interface Source {
  name: string;
  url: string;
  subject: string;
  category: string;
}

export const sources: Source[] = [
  {
    "name": "OpenStax Biology 2e",
    "url": "https://openstax.org/details/books/biology-2e",
    "subject": "AP Biology (& Related Life Sciences)",
    "category": "AP SCIENCES"
  },
  {
    "name": "OpenStax Concepts of Biology",
    "url": "https://openstax.org/details/books/concepts-biology",
    "subject": "AP Biology (& Related Life Sciences)",
    "category": "AP SCIENCES"
  },
  {
    "name": "Biology (LibreTexts Bookshelf)",
    "url": "https://bio.libretexts.org/Bookshelves",
    "subject": "AP Biology (& Related Life Sciences)",
    "category": "AP SCIENCES"
  },
  {
    "name": "Biology — K12 LibreTexts",
    "url": "https://k12.libretexts.org/Bookshelves/Science_and_Technology/Biology",
    "subject": "AP Biology (& Related Life Sciences)",
    "category": "AP SCIENCES"
  },
  {
    "name": "General Biology (Boundless) via LibreTexts",
    "url": "https://bio.libretexts.org/Bookshelves/Introductory_and_General_Biology/Book%3A_General_Biology_(Boundless)",
    "subject": "AP Biology (& Related Life Sciences)",
    "category": "AP SCIENCES"
  },
  {
    "name": "MIT OCW 7.012 Introduction to Biology",
    "url": "https://ocw.mit.edu/courses/7-012-introduction-to-biology-fall-2004/",
    "subject": "AP Biology (& Related Life Sciences)",
    "category": "AP SCIENCES"
  },
  {
    "name": "MIT OCW 7.014 Introductory Biology",
    "url": "https://ocw.mit.edu/courses/7-014-introductory-biology-spring-2005/",
    "subject": "AP Biology (& Related Life Sciences)",
    "category": "AP SCIENCES"
  },
  {
    "name": "PhET Biology Simulations",
    "url": "https://phet.colorado.edu/en/simulations/filter?subjects=biology",
    "subject": "AP Biology (& Related Life Sciences)",
    "category": "AP SCIENCES"
  },
  {
    "name": "OpenStax Microbiology",
    "url": "https://openstax.org/details/books/microbiology",
    "subject": "AP Biology (& Related Life Sciences)",
    "category": "AP SCIENCES"
  },
  {
    "name": "Kimball’s Biology Pages (LibreTexts)",
    "url": "https://bio.libretexts.org/Bookshelves/Introductory_and_General_Biology/Book%3A_Biology_(Kimball)",
    "subject": "AP Biology (& Related Life Sciences)",
    "category": "AP SCIENCES"
  },
  {
    "name": "Online Open Genetics (LibreTexts)",
    "url": "https://bio.libretexts.org/Bookshelves/Genetics/Online_Open_Genetics_(Nickle_and_Barrette-Ng)",
    "subject": "AP Biology (& Related Life Sciences)",
    "category": "AP SCIENCES"
  },
  {
    "name": "Environmental Biology (Open Oregon)",
    "url": "https://bio.libretexts.org/Bookshelves/Ecology/Environmental_Biology_(Fisher)",
    "subject": "AP Biology (& Related Life Sciences)",
    "category": "AP SCIENCES"
  },
  {
    "name": "OpenStax Chemistry 2e",
    "url": "https://openstax.org/details/books/chemistry-2e",
    "subject": "AP Chemistry",
    "category": "AP SCIENCES"
  },
  {
    "name": "OpenStax Chemistry: Atoms First 2e",
    "url": "https://openstax.org/details/books/chemistry-atoms-first-2e",
    "subject": "AP Chemistry",
    "category": "AP SCIENCES"
  },
  {
    "name": "Chemistry LibreTexts Bookshelf",
    "url": "https://chem.libretexts.org/Bookshelves",
    "subject": "AP Chemistry",
    "category": "AP SCIENCES"
  },
  {
    "name": "MIT OCW 5.111 Principles of Chemical Science",
    "url": "https://ocw.mit.edu/courses/5-111sc-principles-of-chemical-science-fall-2014/",
    "subject": "AP Chemistry",
    "category": "AP SCIENCES"
  },
  {
    "name": "MIT OCW 5.112 Principles of Chemical Science",
    "url": "https://ocw.mit.edu/courses/5-112-principles-of-chemical-science-fall-2005/",
    "subject": "AP Chemistry",
    "category": "AP SCIENCES"
  },
  {
    "name": "PhET Chemistry Simulations",
    "url": "https://phet.colorado.edu/en/simulations/filter?subjects=chemistry",
    "subject": "AP Chemistry",
    "category": "AP SCIENCES"
  },
  {
    "name": "General Chemistry 1 (LibreTexts / OIT)",
    "url": "https://chem.libretexts.org/Courses/Oregon_Institute_of_Technology/OIT:*CHE_201*-*General_Chemistry_I*(Anthony_and_Clark)",
    "subject": "AP Chemistry",
    "category": "AP SCIENCES"
  },
  {
    "name": "Virtual Chemistry Textbook (Reusch)",
    "url": "https://www2.chemistry.msu.edu/faculty/reusch/virttxtjml/intro1.htm",
    "subject": "AP Chemistry",
    "category": "AP SCIENCES"
  },
  {
    "name": "OpenStax Organic Chemistry (McMurry)",
    "url": "https://openstax.org/details/books/organic-chemistry",
    "subject": "AP Chemistry",
    "category": "AP SCIENCES"
  },
  {
    "name": "Analytical Chemistry (LibreTexts)",
    "url": "https://chem.libretexts.org/Bookshelves/Analytical_Chemistry",
    "subject": "AP Chemistry",
    "category": "AP SCIENCES"
  },
  {
    "name": "OpenStax College Physics 2e",
    "url": "https://openstax.org/details/books/college-physics-2e",
    "subject": "AP Physics 1 & 2",
    "category": "AP SCIENCES"
  },
  {
    "name": "OpenStax Physics for High School",
    "url": "https://openstax.org/details/books/physics",
    "subject": "AP Physics 1 & 2",
    "category": "AP SCIENCES"
  },
  {
    "name": "Physics LibreTexts Bookshelf",
    "url": "https://phys.libretexts.org/Bookshelves",
    "subject": "AP Physics 1 & 2",
    "category": "AP SCIENCES"
  },
  {
    "name": "MIT OCW 8.01 Physics I: Classical Mechanics",
    "url": "https://ocw.mit.edu/courses/8-01sc-physics-i-classical-mechanics-fall-2016/",
    "subject": "AP Physics 1 & 2",
    "category": "AP SCIENCES"
  },
  {
    "name": "MIT OCW 8.02 Physics II: Electricity and Magnetism",
    "url": "https://ocw.mit.edu/courses/8-02-physics-ii-electricity-and-magnetism-spring-2007/",
    "subject": "AP Physics 1 & 2",
    "category": "AP SCIENCES"
  },
  {
    "name": "PhET Physics Simulations",
    "url": "https://phet.colorado.edu/en/simulations/filter?subjects=physics",
    "subject": "AP Physics 1 & 2",
    "category": "AP SCIENCES"
  },
  {
    "name": "Highlights for High School: AP Physics (MIT OCW)",
    "url": "https://ocw.mit.edu/high-school/physics/",
    "subject": "AP Physics 1 & 2",
    "category": "AP SCIENCES"
  },
  {
    "name": "OpenStax University Physics Vol. 1",
    "url": "https://openstax.org/details/books/university-physics-volume-1",
    "subject": "AP Physics C: Mechanics & Electricity and Magnetism",
    "category": "AP SCIENCES"
  },
  {
    "name": "OpenStax University Physics Vol. 2",
    "url": "https://openstax.org/details/books/university-physics-volume-2",
    "subject": "AP Physics C: Mechanics & Electricity and Magnetism",
    "category": "AP SCIENCES"
  },
  {
    "name": "OpenStax University Physics Vol. 3",
    "url": "https://openstax.org/details/books/university-physics-volume-3",
    "subject": "AP Physics C: Mechanics & Electricity and Magnetism",
    "category": "AP SCIENCES"
  },
  {
    "name": "MIT OCW 8.03 Physics III: Vibrations and Waves",
    "url": "https://ocw.mit.edu/courses/8-03sc-physics-iii-vibrations-and-waves-fall-2016/",
    "subject": "AP Physics C: Mechanics & Electricity and Magnetism",
    "category": "AP SCIENCES"
  },
  {
    "name": "OpenStax Environmental Science",
    "url": "https://openstax.org/details/books/environmental-science",
    "subject": "AP Environmental Science",
    "category": "AP SCIENCES"
  },
  {
    "name": "Environmental Biology (LibreTexts)",
    "url": "https://bio.libretexts.org/Bookshelves/Ecology/Environmental_Biology_(Fisher)",
    "subject": "AP Environmental Science",
    "category": "AP SCIENCES"
  },
  {
    "name": "Introduction to Environmental Science 2e (LibreTexts/Georgia College)",
    "url": "https://bio.libretexts.org/Bookshelves/Ecology/Book%3A_Introductory_Environmental_Sciences_(ENVS2000)",
    "subject": "AP Environmental Science",
    "category": "AP SCIENCES"
  },
  {
    "name": "PhET Earth Science Simulations",
    "url": "https://phet.colorado.edu/en/simulations/filter?subjects=earth-science",
    "subject": "AP Environmental Science",
    "category": "AP SCIENCES"
  },
  {
    "name": "MIT OCW: Climate Change Science",
    "url": "https://ocw.mit.edu/courses/12-340-global-warming-science-spring-2012/",
    "subject": "AP Environmental Science",
    "category": "AP SCIENCES"
  },
  {
    "name": "Geosciences LibreTexts",
    "url": "https://geo.libretexts.org/Bookshelves",
    "subject": "AP Environmental Science",
    "category": "AP SCIENCES"
  },
  {
    "name": "OpenStax Calculus Vol. 1",
    "url": "https://openstax.org/details/books/calculus-volume-1",
    "subject": "AP Calculus AB & BC",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "OpenStax Calculus Vol. 2",
    "url": "https://openstax.org/details/books/calculus-volume-2",
    "subject": "AP Calculus AB & BC",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "OpenStax Calculus Vol. 3",
    "url": "https://openstax.org/details/books/calculus-volume-3",
    "subject": "AP Calculus AB & BC",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "Mathematics LibreTexts — Calculus",
    "url": "https://math.libretexts.org/Bookshelves/Calculus",
    "subject": "AP Calculus AB & BC",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "MIT OCW 18.01 Single Variable Calculus",
    "url": "https://ocw.mit.edu/courses/18-01sc-single-variable-calculus-fall-2010/",
    "subject": "AP Calculus AB & BC",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "MIT OCW 18.02 Multivariable Calculus",
    "url": "https://ocw.mit.edu/courses/18-02sc-multivariable-calculus-fall-2010/",
    "subject": "AP Calculus AB & BC",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "Highlights for High School: AP Calculus (MIT OCW)",
    "url": "https://ocw.mit.edu/high-school/mathematics/",
    "subject": "AP Calculus AB & BC",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "Active Calculus (LibreTexts)",
    "url": "https://math.libretexts.org/Bookshelves/Calculus/Active_Calculus_(Boelkins_et_al.)",
    "subject": "AP Calculus AB & BC",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "Calculus (Guichard, LibreTexts)",
    "url": "https://math.libretexts.org/Bookshelves/Calculus/Calculus_(Guichard)",
    "subject": "AP Calculus AB & BC",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "OpenStax Introductory Statistics",
    "url": "https://openstax.org/details/books/introductory-statistics",
    "subject": "AP Statistics",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "OpenStax Statistics",
    "url": "https://openstax.org/details/books/statistics",
    "subject": "AP Statistics",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "OnlineStatBook (Lane, Rice University)",
    "url": "https://onlinestatbook.com/",
    "subject": "AP Statistics",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "Statistics LibreTexts Bookshelf",
    "url": "https://stats.libretexts.org/Bookshelves",
    "subject": "AP Statistics",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "MIT OCW 18.650 Statistics for Applications",
    "url": "https://ocw.mit.edu/courses/18-650-statistics-for-applications-fall-2016/",
    "subject": "AP Statistics",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "Introductory Statistics (Shafer and Zhang, LibreTexts)",
    "url": "https://stats.libretexts.org/Bookshelves/Introductory_Statistics/Introductory_Statistics_(Shafer_and_Zhang)",
    "subject": "AP Statistics",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "PhET Statistics Simulations",
    "url": "https://phet.colorado.edu/en/simulations/plinko-probability",
    "subject": "AP Statistics",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "OpenStax Precalculus 2e",
    "url": "https://openstax.org/details/books/precalculus-2e",
    "subject": "AP Precalculus",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "OpenStax College Algebra 2e",
    "url": "https://openstax.org/details/books/college-algebra-2e",
    "subject": "AP Precalculus",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "OpenStax Algebra and Trigonometry 2e",
    "url": "https://openstax.org/details/books/algebra-and-trigonometry-2e",
    "subject": "AP Precalculus",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "OpenStax Elementary Algebra 2e",
    "url": "https://openstax.org/details/books/elementary-algebra-2e",
    "subject": "AP Precalculus",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "Mathematics LibreTexts — Precalculus",
    "url": "https://math.libretexts.org/Bookshelves/Precalculus",
    "subject": "AP Precalculus",
    "category": "AP MATHEMATICS"
  },
  {
    "name": "CSAwesome2 (Runestone Academy)",
    "url": "https://runestone.academy/ns/books/published/csawesome2/csawesome2.html",
    "subject": "AP Computer Science A (Java)",
    "category": "AP COMPUTER SCIENCE"
  },
  {
    "name": "CSAwesome v1 (Runestone Academy)",
    "url": "https://runestone.academy/ns/books/published/csawesome/index.html",
    "subject": "AP Computer Science A (Java)",
    "category": "AP COMPUTER SCIENCE"
  },
  {
    "name": "CSAwesome GitHub Repository",
    "url": "https://github.com/bhoffman0/CSAwesome",
    "subject": "AP Computer Science A (Java)",
    "category": "AP COMPUTER SCIENCE"
  },
  {
    "name": "MIT OCW 6.0001 Introduction to CS in Python",
    "url": "https://ocw.mit.edu/courses/6-0001-introduction-to-computer-science-and-programming-in-python-fall-2016/",
    "subject": "AP Computer Science A (Java)",
    "category": "AP COMPUTER SCIENCE"
  },
  {
    "name": "How to Think Like a Computer Scientist (LibreTexts)",
    "url": "https://runestone.academy/ns/books/published/thinkcspy/index.html",
    "subject": "AP Computer Science A (Java)",
    "category": "AP COMPUTER SCIENCE"
  },
  {
    "name": "MIT OCW 6.092 Introduction to Programming in Java",
    "url": "https://ocw.mit.edu/courses/6-092-introduction-to-programming-in-java-january-iap-2010/",
    "subject": "AP Computer Science A (Java)",
    "category": "AP COMPUTER SCIENCE"
  },
  {
    "name": "Mobile CSP (Runestone Academy)",
    "url": "https://runestone.academy/ns/books/published/mobilecsp/index.html",
    "subject": "AP Computer Science Principles",
    "category": "AP COMPUTER SCIENCE"
  },
  {
    "name": "Beauty and Joy of Computing (BJC)",
    "url": "https://bjc.edc.org/",
    "subject": "AP Computer Science Principles",
    "category": "AP COMPUTER SCIENCE"
  },
  {
    "name": "MIT OCW 6.0002 Introduction to Computational Thinking and Data Science",
    "url": "https://ocw.mit.edu/courses/6-0002-introduction-to-computational-thinking-and-data-science-fall-2016/",
    "subject": "AP Computer Science Principles",
    "category": "AP COMPUTER SCIENCE"
  },
  {
    "name": "Think Python (LibreTexts)",
    "url": "https://runestone.academy/ns/books/published/thinkcspy/index.html",
    "subject": "AP Computer Science Principles",
    "category": "AP COMPUTER SCIENCE"
  },
  {
    "name": "Writing Commons",
    "url": "https://writingcommons.org/",
    "subject": "AP English Language & Composition",
    "category": "AP ENGLISH"
  },
  {
    "name": "The Craft of Research (Chicago Guides) — LibreTexts excerpt",
    "url": "https://human.libretexts.org/Bookshelves/Composition",
    "subject": "AP English Language & Composition",
    "category": "AP ENGLISH"
  },
  {
    "name": "Project Gutenberg",
    "url": "https://www.gutenberg.org/",
    "subject": "AP English Language & Composition",
    "category": "AP ENGLISH"
  },
  {
    "name": "MIT OpenCourseWare: Rhetoric",
    "url": "https://ocw.mit.edu/courses/21w-747-rhetoric-spring-2015/",
    "subject": "AP English Language & Composition",
    "category": "AP ENGLISH"
  },
  {
    "name": "Writing in College: From Competence to Excellence (SUNY)",
    "url": "https://milneopentextbooks.org/writing-in-college-from-competence-to-excellence/",
    "subject": "AP English Language & Composition",
    "category": "AP ENGLISH"
  },
  {
    "name": "Choosing and Using Sources (Ohio State)",
    "url": "https://ohiostate.pressbooks.pub/choosingsources/",
    "subject": "AP English Language & Composition",
    "category": "AP ENGLISH"
  },
  {
    "name": "A Guide to Rhetoric, Genre, and Success in First-Year Writing (LibreTexts)",
    "url": "https://human.libretexts.org/Bookshelves/Composition/Introductory_Composition/A_Guide_to_Rhetoric_Genre_and_Success_in_First_Year_Writing_(Babin_et_al.)",
    "subject": "AP English Language & Composition",
    "category": "AP ENGLISH"
  },
  {
    "name": "Purdue OWL (Open Writing Lab)",
    "url": "https://owl.purdue.edu/owl/general_writing/index.html",
    "subject": "AP English Language & Composition",
    "category": "AP ENGLISH"
  },
  {
    "name": "Project Gutenberg — Top Literature",
    "url": "https://www.gutenberg.org/browse/scores/top",
    "subject": "AP English Literature & Composition",
    "category": "AP ENGLISH"
  },
  {
    "name": "Standard Ebooks",
    "url": "https://standardebooks.org/",
    "subject": "AP English Literature & Composition",
    "category": "AP ENGLISH"
  },
  {
    "name": "Internet Archive: Classic Literature",
    "url": "https://archive.org/details/texts",
    "subject": "AP English Literature & Composition",
    "category": "AP ENGLISH"
  },
  {
    "name": "Bartleby.com",
    "url": "https://www.bartleby.com/",
    "subject": "AP English Literature & Composition",
    "category": "AP ENGLISH"
  },
  {
    "name": "Poetry Foundation",
    "url": "https://www.poetryfoundation.org/",
    "subject": "AP English Literature & Composition",
    "category": "AP ENGLISH"
  },
  {
    "name": "Introduction to Literature (LibreTexts)",
    "url": "https://human.libretexts.org/Bookshelves/Literature_and_Literacy/Introduction_to_Literature",
    "subject": "AP English Literature & Composition",
    "category": "AP ENGLISH"
  },
  {
    "name": "Open Literature Anthology (LibreTexts)",
    "url": "https://human.libretexts.org/Bookshelves/Literature_and_Literacy",
    "subject": "AP English Literature & Composition",
    "category": "AP ENGLISH"
  },
  {
    "name": "The American Yawp Vol. I: To 1877",
    "url": "https://www.americanyawp.com/text/",
    "subject": "AP United States History (APUSH)",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "The American Yawp Vol. II: Since 1877",
    "url": "https://open.umn.edu/opentextbooks/textbooks/778",
    "subject": "AP United States History (APUSH)",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "OpenStax U.S. History",
    "url": "https://openstax.org/details/books/us-history",
    "subject": "AP United States History (APUSH)",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "U.S. History via LibreTexts (American YAWP)",
    "url": "https://human.libretexts.org/Bookshelves/History/National_History/U.S.*History*(American_YAWP)",
    "subject": "AP United States History (APUSH)",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "Digital History (University of Houston)",
    "url": "https://www.digitalhistory.uh.edu/",
    "subject": "AP United States History (APUSH)",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "Library of Congress Primary Sources",
    "url": "https://www.loc.gov/collections/",
    "subject": "AP United States History (APUSH)",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "National Archives Docs Teach",
    "url": "https://www.archives.gov/education",
    "subject": "AP United States History (APUSH)",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "Digital Public Library of America (DPLA)",
    "url": "https://dp.la/",
    "subject": "AP United States History (APUSH)",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "History Matters (George Mason University)",
    "url": "https://historymatters.gmu.edu/",
    "subject": "AP United States History (APUSH)",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "A History of the United States (LibreTexts)",
    "url": "https://human.libretexts.org/Bookshelves/History/National_History/A_History_of_the_United_States_(1870-Present)",
    "subject": "AP United States History (APUSH)",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "OpenStax World History Vol. 1: to 1500",
    "url": "https://openstax.org/details/books/world-history-volume-1",
    "subject": "AP World History: Modern",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "OpenStax World History Vol. 2: from 1400",
    "url": "https://openstax.org/details/books/world-history-volume-2",
    "subject": "AP World History: Modern",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "World History: Cultures, States, and Societies to 1500 (Open Textbook Library)",
    "url": "https://open.umn.edu/opentextbooks/textbooks/375",
    "subject": "AP World History: Modern",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "World History Since 1500: An Open and Free Textbook",
    "url": "https://open.umn.edu/opentextbooks/textbooks/world-history-since-1500-an-open-and-free-textbook",
    "subject": "AP World History: Modern",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "Modern World History (Open Textbook Library)",
    "url": "https://open.umn.edu/opentextbooks/textbooks/949",
    "subject": "AP World History: Modern",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "World History Encyclopedia — Education Resources",
    "url": "https://www.worldhistory.org/edu/",
    "subject": "AP World History: Modern",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "Ancient Civilizations (LibreTexts)",
    "url": "https://human.libretexts.org/Bookshelves/History/Ancient_and_Medieval_History",
    "subject": "AP World History: Modern",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "Western Civilization: A Concise History Vol. 1 (Open Textbook Library)",
    "url": "https://open.umn.edu/opentextbooks/textbooks/western-civilization-a-concise-history-volume-1",
    "subject": "AP World History: Modern",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "Western Civilization: A Concise History Vol. 2 (Open Textbook Library)",
    "url": "https://open.umn.edu/opentextbooks/textbooks/western-civilization-a-concise-history-volume-2",
    "subject": "AP World History: Modern",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "Western Civilization: A Concise History Vol. 3 (Open Textbook Library)",
    "url": "https://open.umn.edu/opentextbooks/textbooks/western-civilization-a-concise-history-volume-3",
    "subject": "AP World History: Modern",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "Western Civilization (LibreTexts Hub)",
    "url": "https://human.libretexts.org/Bookshelves/History/Western_Civilization",
    "subject": "AP European History",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "MIT OCW 21H.141 European History and Texts",
    "url": "https://ocw.mit.edu/courses/21h-141-europe-in-the-age-of-religious-warfare-1200-1715-fall-2004/",
    "subject": "AP European History",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "A Comprehensive Outline of World History (Jack E. Maxfield, LibreTexts)",
    "url": "https://human.libretexts.org/Bookshelves/History/World_History/A_Comprehensive_Outline_of_World_History_(Maxfield)",
    "subject": "AP European History",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "OpenStax American Government 3e",
    "url": "https://openstax.org/details/books/american-government-3e",
    "subject": "AP US Government & Politics",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "OpenStax Introduction to Political Science",
    "url": "https://openstax.org/details/books/introduction-political-science",
    "subject": "AP US Government & Politics",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "US Government and Politics (LibreTexts)",
    "url": "https://socialsci.libretexts.org/Bookshelves/Political_Science_and_Civics",
    "subject": "AP US Government & Politics",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "Congress.gov",
    "url": "https://www.congress.gov/",
    "subject": "AP US Government & Politics",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "Supreme Court Opinions Archive",
    "url": "https://www.supremecourt.gov/opinions/opinions.aspx",
    "subject": "AP US Government & Politics",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "Constitution Center: Interactive Constitution",
    "url": "https://constitutioncenter.org/the-constitution",
    "subject": "AP US Government & Politics",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "An Introduction to Politics (LibreTexts)",
    "url": "https://socialsci.libretexts.org/Bookshelves/Political_Science_and_Civics/An_Introduction_to_Politics_(Barth)",
    "subject": "AP US Government & Politics",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "Comparative Politics and Government (LibreTexts)",
    "url": "https://socialsci.libretexts.org/Bookshelves/Political_Science_and_Civics",
    "subject": "AP Comparative Government & Politics",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "MIT OCW 17.50 Introduction to Comparative Politics",
    "url": "https://ocw.mit.edu/courses/17-50-introduction-to-comparative-politics-fall-2006/",
    "subject": "AP Comparative Government & Politics",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "World Regional Geography: People, Places and Globalization (Saylor/LibreTexts)",
    "url": "https://socialsci.libretexts.org/Bookshelves/Geography_(Physical)/World_Regional_Geography_(Finlayson)",
    "subject": "AP Human Geography",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "Introduction to Human Geography (LibreTexts)",
    "url": "https://socialsci.libretexts.org/Bookshelves/Geography_(Human)",
    "subject": "AP Human Geography",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "MIT OCW 11.520 Workshop on GIS",
    "url": "https://ocw.mit.edu/courses/11-520-a-workshop-on-geographic-information-systems-fall-2005/",
    "subject": "AP Human Geography",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "World Bank Open Data",
    "url": "https://data.worldbank.org/",
    "subject": "AP Human Geography",
    "category": "AP HISTORY & SOCIAL STUDIES"
  },
  {
    "name": "OpenStax Principles of Macroeconomics 3e",
    "url": "https://openstax.org/details/books/principles-macroeconomics-3e",
    "subject": "AP Macroeconomics",
    "category": "AP ECONOMICS"
  },
  {
    "name": "Economics LibreTexts — Macroeconomics",
    "url": "https://socialsci.libretexts.org/Bookshelves/Economics/Macroeconomics",
    "subject": "AP Macroeconomics",
    "category": "AP ECONOMICS"
  },
  {
    "name": "MIT OCW 14.02 Principles of Macroeconomics",
    "url": "https://ocw.mit.edu/courses/14-02-principles-of-macroeconomics-spring-2014/",
    "subject": "AP Macroeconomics",
    "category": "AP ECONOMICS"
  },
  {
    "name": "Library of Economics and Liberty (Econlib)",
    "url": "https://www.econlib.org/library/enc.html",
    "subject": "AP Macroeconomics",
    "category": "AP ECONOMICS"
  },
  {
    "name": "Macroeconomics (Greenlaw and Shapiro, LibreTexts)",
    "url": "https://socialsci.libretexts.org/Bookshelves/Economics/Macroeconomics_(Greenlaw_and_Shapiro)",
    "subject": "AP Macroeconomics",
    "category": "AP ECONOMICS"
  },
  {
    "name": "OpenStax Principles of Microeconomics 3e",
    "url": "https://openstax.org/details/books/principles-microeconomics-3e",
    "subject": "AP Microeconomics",
    "category": "AP ECONOMICS"
  },
  {
    "name": "Economics LibreTexts — Microeconomics",
    "url": "https://socialsci.libretexts.org/Bookshelves/Economics/Microeconomics",
    "subject": "AP Microeconomics",
    "category": "AP ECONOMICS"
  },
  {
    "name": "MIT OCW 14.01 Principles of Microeconomics",
    "url": "https://ocw.mit.edu/courses/14-01-principles-of-microeconomics-fall-2018/",
    "subject": "AP Microeconomics",
    "category": "AP ECONOMICS"
  },
  {
    "name": "Microeconomics (Bouman, LibreTexts)",
    "url": "https://socialsci.libretexts.org/Bookshelves/Economics/Microeconomics_(Bouman)",
    "subject": "AP Microeconomics",
    "category": "AP ECONOMICS"
  },
  {
    "name": "PhET Economics Simulations: Plinko/Probability",
    "url": "https://phet.colorado.edu/en/simulations/plinko-probability",
    "subject": "AP Microeconomics",
    "category": "AP ECONOMICS"
  },
  {
    "name": "OpenStax Psychology 2e",
    "url": "https://openstax.org/details/books/psychology-2e",
    "subject": "",
    "category": "AP PSYCHOLOGY"
  },
  {
    "name": "Noba Project: Introduction to Psychology",
    "url": "https://nobaproject.com/",
    "subject": "",
    "category": "AP PSYCHOLOGY"
  },
  {
    "name": "Introduction to Psychology — Full Noba Collection (Open Textbook Library)",
    "url": "https://open.umn.edu/opentextbooks/textbooks/introduction-to-psychology-the-full-noba-collection",
    "subject": "",
    "category": "AP PSYCHOLOGY"
  },
  {
    "name": "Psychology (LibreTexts)",
    "url": "https://socialsci.libretexts.org/Bookshelves/Psychology",
    "subject": "",
    "category": "AP PSYCHOLOGY"
  },
  {
    "name": "OpenStax Lifespan Development",
    "url": "https://openstax.org/details/books/lifespan-development",
    "subject": "",
    "category": "AP PSYCHOLOGY"
  },
  {
    "name": "Introduction to Psychology — BC Campus (Stangor/Wallinga)",
    "url": "https://opentextbc.ca/introductiontopsychology/",
    "subject": "",
    "category": "AP PSYCHOLOGY"
  },
  {
    "name": "Noba: Social Psychology Module",
    "url": "https://nobaproject.com/modules/an-introduction-to-the-science-of-social-psychology",
    "subject": "",
    "category": "AP PSYCHOLOGY"
  },
  {
    "name": "MIT OCW 9.00 Introduction to Psychology",
    "url": "https://ocw.mit.edu/courses/9-00sc-introduction-to-psychology-fall-2011/",
    "subject": "",
    "category": "AP PSYCHOLOGY"
  },
  {
    "name": "Principles of Social Psychology (LibreTexts)",
    "url": "https://socialsci.libretexts.org/Bookshelves/Social_Psychology",
    "subject": "",
    "category": "AP PSYCHOLOGY"
  },
  {
    "name": "Smarthistory — Full Resource",
    "url": "https://smarthistory.org/",
    "subject": "AP Art History",
    "category": "AP ARTS"
  },
  {
    "name": "Smarthistory: Reframing Art History",
    "url": "https://smarthistory.org/reframing-art-history/",
    "subject": "AP Art History",
    "category": "AP ARTS"
  },
  {
    "name": "Smarthistory: AP Art History Resources",
    "url": "https://smarthistory.org/ap-art-history/",
    "subject": "AP Art History",
    "category": "AP ARTS"
  },
  {
    "name": "Smarthistory Guide to AP Art History Vol. 1 (OER Commons)",
    "url": "https://oercommons.org/courses/smarthistory-guide-to-ap-art-history-volume-1",
    "subject": "AP Art History",
    "category": "AP ARTS"
  },
  {
    "name": "Metropolitan Museum of Art: Timeline of Art History",
    "url": "https://www.metmuseum.org/toah/",
    "subject": "AP Art History",
    "category": "AP ARTS"
  },
  {
    "name": "National Gallery of Art: Open Access",
    "url": "https://www.nga.gov/open-access-images.html",
    "subject": "AP Art History",
    "category": "AP ARTS"
  },
  {
    "name": "Art History (LibreTexts)",
    "url": "https://human.libretexts.org/Bookshelves/Art",
    "subject": "AP Art History",
    "category": "AP ARTS"
  },
  {
    "name": "Flickr: AP Art History Images (Prof. Zucker/Smarthistory)",
    "url": "https://www.flickr.com/photos/profzucker/albums/72157648851606647/",
    "subject": "AP Art History",
    "category": "AP ARTS"
  },
  {
    "name": "MIT OCW 4.601 Introduction to the History and Theory of Architecture",
    "url": "https://ocw.mit.edu/courses/4-601-introduction-to-the-history-and-theory-of-architecture-fall-2006/",
    "subject": "AP Art History",
    "category": "AP ARTS"
  },
  {
    "name": "Open Music Theory Version 2 (viva.pressbooks.pub)",
    "url": "https://viva.pressbooks.pub/openmusictheory/",
    "subject": "AP Music Theory",
    "category": "AP ARTS"
  },
  {
    "name": "Open Music Theory (openmusictheory.github.io)",
    "url": "https://openmusictheory.github.io/",
    "subject": "AP Music Theory",
    "category": "AP ARTS"
  },
  {
    "name": "Open Music Theory — Open Textbook Library Review",
    "url": "https://open.umn.edu/opentextbooks/textbooks/1254",
    "subject": "AP Music Theory",
    "category": "AP ARTS"
  },
  {
    "name": "Open Music Theory × CUNY",
    "url": "https://ycmusictheory.commons.gc.cuny.edu/",
    "subject": "AP Music Theory",
    "category": "AP ARTS"
  },
  {
    "name": "Music Theory (LibreTexts)",
    "url": "https://human.libretexts.org/Bookshelves/Music",
    "subject": "AP Music Theory",
    "category": "AP ARTS"
  },
  {
    "name": "MIT OCW 21M.301 Harmony and Counterpoint I",
    "url": "https://ocw.mit.edu/courses/21m-301-harmony-and-counterpoint-i-spring-2005/",
    "subject": "AP Music Theory",
    "category": "AP ARTS"
  },
  {
    "name": "MuseScore Open Sheet Music",
    "url": "https://musescore.com/sheetmusic?license=to_share",
    "subject": "AP Music Theory",
    "category": "AP ARTS"
  },
  {
    "name": "International Music Score Library Project (IMSLP)",
    "url": "https://imslp.org/",
    "subject": "AP Music Theory",
    "category": "AP ARTS"
  },
  {
    "name": "Spanish via LibreTexts",
    "url": "https://human.libretexts.org/Bookshelves/Languages",
    "subject": "AP Spanish Language & Culture",
    "category": "AP WORLD LANGUAGES"
  },
  {
    "name": "MIT OCW 21G.703 Spanish III",
    "url": "https://ocw.mit.edu/courses/21g-703-spanish-iii-fall-2003/",
    "subject": "AP Spanish Language & Culture",
    "category": "AP WORLD LANGUAGES"
  },
  {
    "name": "Spanish Grammar (Wikibooks)",
    "url": "https://en.wikibooks.org/wiki/Spanish",
    "subject": "AP Spanish Language & Culture",
    "category": "AP WORLD LANGUAGES"
  },
  {
    "name": "Biblioteca Virtual Miguel de Cervantes",
    "url": "https://www.cervantesvirtual.com/",
    "subject": "AP Spanish Language & Culture",
    "category": "AP WORLD LANGUAGES"
  },
  {
    "name": "French via LibreTexts",
    "url": "https://human.libretexts.org/Bookshelves/Languages",
    "subject": "AP French Language & Culture",
    "category": "AP WORLD LANGUAGES"
  },
  {
    "name": "MIT OCW 21G.301 French I",
    "url": "https://ocw.mit.edu/courses/21g-301-french-i-fall-2004/",
    "subject": "AP French Language & Culture",
    "category": "AP WORLD LANGUAGES"
  },
  {
    "name": "French Grammar (Wikibooks)",
    "url": "https://en.wikibooks.org/wiki/French",
    "subject": "AP French Language & Culture",
    "category": "AP WORLD LANGUAGES"
  },
  {
    "name": "Wikisource French",
    "url": "https://fr.wikisource.org/",
    "subject": "AP French Language & Culture",
    "category": "AP WORLD LANGUAGES"
  },
  {
    "name": "MIT OCW 21G.401 German I",
    "url": "https://ocw.mit.edu/courses/21g-401-german-i-fall-2019/",
    "subject": "AP German Language & Culture",
    "category": "AP WORLD LANGUAGES"
  },
  {
    "name": "German via Wikibooks",
    "url": "https://en.wikibooks.org/wiki/German",
    "subject": "AP German Language & Culture",
    "category": "AP WORLD LANGUAGES"
  },
  {
    "name": "Perseus Digital Library",
    "url": "https://www.perseus.tufts.edu/",
    "subject": "AP Latin",
    "category": "AP WORLD LANGUAGES"
  },
  {
    "name": "The Latin Library",
    "url": "https://www.thelatinlibrary.com/",
    "subject": "AP Latin",
    "category": "AP WORLD LANGUAGES"
  },
  {
    "name": "Virgil’s Aeneid (Perseus, Latin + English)",
    "url": "https://www.perseus.tufts.edu/hopper/text?doc=Perseus%3Atext%3A1999.02.0001",
    "subject": "AP Latin",
    "category": "AP WORLD LANGUAGES"
  },
  {
    "name": "Caesar’s Gallic Wars (Perseus)",
    "url": "https://www.perseus.tufts.edu/hopper/text?doc=Perseus:text:1999.02.0001",
    "subject": "AP Latin",
    "category": "AP WORLD LANGUAGES"
  },
  {
    "name": "MIT OCW 21L.015 Introduction to Latin",
    "url": "https://ocw.mit.edu/courses/21l-015-introduction-to-latin-fall-2003/",
    "subject": "AP Latin",
    "category": "AP WORLD LANGUAGES"
  },
  {
    "name": "MIT OCW 21G.101 Chinese I",
    "url": "https://ocw.mit.edu/courses/21g-101-chinese-i-regular-fall-2014/",
    "subject": "AP Chinese Language & Culture",
    "category": "AP WORLD LANGUAGES"
  },
  {
    "name": "Chinese Grammar Wiki",
    "url": "https://resources.allsetlearning.com/chinese/grammar/Main_Page",
    "subject": "AP Chinese Language & Culture",
    "category": "AP WORLD LANGUAGES"
  },
  {
    "name": "MIT OCW 21G.504 Japanese IV",
    "url": "https://ocw.mit.edu/courses/21g-504-japanese-iv-spring-2020/",
    "subject": "AP Japanese Language & Culture",
    "category": "AP WORLD LANGUAGES"
  },
  {
    "name": "OpenStax Introduction to Sociology 3e",
    "url": "https://openstax.org/details/books/introduction-sociology-3e",
    "subject": "",
    "category": "AP HUMAN GEOGRAPHY / SOCIOLOGY / OTHER SOCIAL SCIENCES"
  },
  {
    "name": "OpenStax Introduction to Anthropology",
    "url": "https://openstax.org/details/books/introduction-anthropology",
    "subject": "",
    "category": "AP HUMAN GEOGRAPHY / SOCIOLOGY / OTHER SOCIAL SCIENCES"
  },
  {
    "name": "Social Sciences LibreTexts",
    "url": "https://socialsci.libretexts.org/Bookshelves",
    "subject": "",
    "category": "AP HUMAN GEOGRAPHY / SOCIOLOGY / OTHER SOCIAL SCIENCES"
  },
  {
    "name": "MIT OCW: Social Science Courses",
    "url": "https://ocw.mit.edu/search/?d=Social+Science",
    "subject": "",
    "category": "AP HUMAN GEOGRAPHY / SOCIOLOGY / OTHER SOCIAL SCIENCES"
  },
  {
    "name": "OpenStax — All Subjects Hub",
    "url": "https://openstax.org/subjects",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "LibreTexts — All 16 Libraries",
    "url": "https://libretexts.org/",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "Open Textbook Library (University of Minnesota)",
    "url": "https://open.umn.edu/opentextbooks/",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "OER Commons",
    "url": "https://www.oercommons.org/",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "MIT OpenCourseWare — Full Catalog",
    "url": "https://ocw.mit.edu/",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "MIT OCW Highlights for High School",
    "url": "https://ocw.mit.edu/high-school/",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "PhET Interactive Simulations — All Subjects",
    "url": "https://phet.colorado.edu/",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "Runestone Academy — Full Library",
    "url": "https://runestone.academy/ns/books/index",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "Pressbooks Directory",
    "url": "https://pressbooks.directory/",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "MERLOT (Multimedia Educational Resource for Learning and Teaching)",
    "url": "https://www.merlot.org/",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "OpenDOAR (Directory of Open Access Repositories)",
    "url": "https://v2.sherpa.ac.uk/opendoar/",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "BC Open Textbooks",
    "url": "https://open.bccampus.ca/browse-our-collection/",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "SUNY Milne Open Textbooks",
    "url": "https://milneopentextbooks.org/",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "Wikiversity",
    "url": "https://en.wikiversity.org/wiki/Wikiversity:Main_Page",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "Wikibooks",
    "url": "https://en.wikibooks.org/",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "OpenLearn (Open University UK)",
    "url": "https://www.open.edu/openlearn/",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "CK-12 FlexBooks (older openly licensed content)",
    "url": "https://www.ck12.org/",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "Smithsonian Open Access",
    "url": "https://www.si.edu/openaccess",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "Internet Archive Open Library",
    "url": "https://archive.org/details/texts",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "OpenLearn Create",
    "url": "https://www.open.edu/openlearncreate/",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  },
  {
    "name": "DOAB: Directory of Open Access Books",
    "url": "https://www.doabooks.org/",
    "subject": "",
    "category": "️ MULTI-SUBJECT"
  }
];

// Grouped helper
export function groupedSources(): Record<string, Record<string, Source[]>> {
  const result: Record<string, Record<string, Source[]>> = {};
  for (const s of sources) {
    if (!result[s.category]) result[s.category] = {};
    if (!result[s.category][s.subject]) result[s.category][s.subject] = [];
    result[s.category][s.subject].push(s);
  }
  return result;
}
